import React, { useRef, useState } from "react";
import BackButton from "../utils/BackButton";
import { useUpload } from "../stores/houseStore";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";

const MAX_FILES = 10;

const UploadMedia = ({ step, setStep, id }) => {
    const [files, setFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const upload = useUpload();
    const refreshAccessToken = useAuthStore((state) => state.refreshAccessToken);
    const fileInputRef = useRef(null);

    const handleButtonClick = () => fileInputRef.current?.click();

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files || []);
        setError(null);

        if (!selectedFiles.length) return;

        const totalFiles = files.length + selectedFiles.length;

        if (totalFiles > MAX_FILES) {
            setError(`Можно загрузить максимум ${MAX_FILES} файлов.`);
            const allowedFiles = selectedFiles.slice(0, MAX_FILES - files.length);
            setFiles((prev) => [...prev, ...allowedFiles]);
        } else {
            setFiles((prev) => [...prev, ...selectedFiles]);
        }

        e.target.value = "";
    };

    const handleRemoveFile = (index) => {
        setFiles((prev) => prev.filter((_, i) => i !== index));
        setError(null);
    };

    const handleUpload = async () => {
        if (!id) {
            setError("Не удалось определить созданное объявление. Вернитесь назад и попробуйте снова.");
            return;
        }

        if (!files.length) {
            setError("Выберите хотя бы один файл для загрузки.");
            return;
        }

        setLoading(true);
        setError(null);

        try {
            let currentToken = localStorage.getItem("access_token");
            const expiryDate = localStorage.getItem("expiry_date");
            const expiresInMs = expiryDate ? new Date(expiryDate).getTime() - Date.now() : null;

            if (expiresInMs !== null && expiresInMs <= 60 * 1000) {
                currentToken = await refreshAccessToken();
            }

            if (!currentToken) {
                setError("Сессия истекла. Войдите заново и попробуйте загрузить файлы.");
                return;
            }

            const uploadedIds = await upload(id, files, currentToken);
            if (!uploadedIds) {
                setError("Ошибка загрузки файлов. Попробуйте снова.");
                return;
            }
            console.log("Загруженные файлы:", uploadedIds);
            navigate(`/detail/house/${id}`);
        } catch (e) {
            setError("Ошибка загрузки файлов. Попробуйте снова.");
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div>
                <label className="block text-black/70 text-sm mb-1">Загрузить медиа (макс. 10 файлов за раз)</label>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    multiple
                    accept="image/*"
                    className="hidden"
                />
                <button
                    type="button"
                    onClick={handleButtonClick}
                    className="w-full bg-white/35 text-black/70 border rounded-md px-3 py-2 focus:outline-none focus:shadow-md"
                >
                    + Добавить файлы
                </button>

                <div className="mt-3 space-y-1 max-h-40 overflow-auto">
                    {files.map((file, index) => (
                        <div
                            key={index}
                            className="flex justify-between items-center text-xs text-black/60 bg-black/5 px-2 py-1 rounded"
                        >
                            <span>{file.name}</span>
                            <button
                                type="button"
                                onClick={() => handleRemoveFile(index)}
                                className="text-red-500 hover:text-red-700"
                            >
                                ✕
                            </button>
                        </div>
                    ))}
                </div>
            </div>

            {error && <p className="text-red-500 text-sm mt-2">{error}</p>}

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mt-4">
                <BackButton step={step} setStep={setStep} />
                <button
                    onClick={handleUpload}
                    type="button"
                    disabled={loading}
                    className="w-full bg-black/60 duration-300 text-white py-2 rounded-lg hover:bg-black transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {loading ? "Загрузка..." : "Создать объявление"}
                </button>
            </div>
        </>
    );
};

export default UploadMedia;
